import * as React from 'react';
import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { change, InjectedFormProps, reduxForm } from 'redux-form';
import { PageHeader } from 'common/components/page-header';
import { StateStatus } from 'common/interfaces/account';
import { State } from 'common/interfaces/state';
import { AccountActions } from 'unit-account/actions/creators';
import { PROFILE } from '../../../../constants/forms';
import { AppUrls } from '../../../../routes/app-urls';
import { ProfileSection } from './sections';
import { Styled } from './styled';

interface InitialData {
  firstName: string;
  lastName: string;
  companyName?: string;
  companyId?: number;
  email: string;
  resetAvatar?: boolean;
  avatarFile?: string;
}

interface StateProps {
  userId: string;
  hasAvatar: boolean;
  accountStatus: StateStatus;
  userHasOwnCompany: boolean;
  submitDisabled: boolean;
  initialData: InitialData;
}

interface ReduxActions {
  setImage: (name: string) => void;
  deleteImage: () => void;
  saveProfileSettings: () => void;
}

interface Props extends StateProps, ReduxActions, InjectedFormProps<{}, {}> { }

export const ProfileFormComponent: React.FC<Props> = (props) => {
  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (e): void => {
    e.preventDefault();
    if (!props.submitDisabled) {
      props.saveProfileSettings();
    }
  };

  React.useEffect(
    () => {
      if (props.userId) {
        props.initialize(props.initialData);
      }
    },
    [props.userId],
  );

  return (
    <Styled.Container>
      <Styled.Header>
        <PageHeader
          redirectUrl={AppUrls.products.path}
        />
      </Styled.Header>
      <Styled.Main>
        <form
          // eslint-disable-next-line react/jsx-no-bind
          onSubmit={handleSubmit}
          autoComplete='off'
          role='presentation'
        >
          <ProfileSection
            userId={props.userId}
            hasAvatar={props.hasAvatar}
            setImage={props.setImage}
            deleteImage={props.deleteImage}
            accountStatus={props.accountStatus}
            canEditCompany={props.userHasOwnCompany}
            submitDisabled={props.submitDisabled}
          />
        </form >
      </Styled.Main>
    </Styled.Container>
  );
};

const mapStateToProps = (state: State): StateProps => {
  const { account, form } = state;
  const ownedCompany = account.ownedCompany;
  const userHasOwnCompany = !!ownedCompany;
  const companies = account.companies;
  const userCompany = userHasOwnCompany && companies && companies.find(company => company.id === ownedCompany.id);
  const formData = form[PROFILE] && form[PROFILE].values;
  const submitDisabled = !formData || !formData.firstName || !formData.lastName
    || (!!formData.oldPassword && !formData.newPassword) || (!formData.oldPassword && !!formData.newPassword);

  return {
    userHasOwnCompany,
    initialData: {
      firstName: account.firstName,
      lastName: account.lastName,
      companyName: userCompany ? userCompany.name : null,
      companyId: userCompany ? userCompany.id : null,
      email: account.email,
      resetAvatar: false,
    },
    userId: account.id,
    hasAvatar: account.hasAvatar,
    accountStatus: account.status,
    submitDisabled,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): ReduxActions => {
  return {
    setImage: (name: string) => dispatch(change(PROFILE, 'avatarFile', name)),
    deleteImage: () => dispatch(change(PROFILE, 'resetAvatar', true)),
    saveProfileSettings: () => dispatch(AccountActions.setUserInfo()),
  };
};

export const ProfileForm = reduxForm<any, any>({
  form: PROFILE,
  destroyOnUnmount: true,
  initialValues: {

  },
})(connect(mapStateToProps, mapDispatchToProps)(ProfileFormComponent));
